import React, { useEffect } from 'react';
import { GoogleMap, LoadScript, Marker, Polyline } from '@react-google-maps/api';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentIndex } from '../../redux/droneSlice';

const containerStyle = {
  width: '100%',
  height: '100vh',
};

const DroneGoogleMap = () => {
  const { drones } = useSelector((state) => state.drone);
  const dispatch = useDispatch();
  const [mapCenter, setMapCenter] = React.useState({ lat: 20.5937, lng: 78.9629 });
  const [zoom,setZoom] = React.useState(5);
  
  // const markerRef = useRef([]);

  useEffect(() => {
    const intervals = drones.map((drone) => {
      if (drone.isSimulating && drone.currentIndex < drone.path.length - 1) {
        return setInterval(() => {
          dispatch(
            updateCurrentIndex({
              id: drone.id,
              index: drone.currentIndex + 1,
            })
          );
          setMapCenter(drone.path[drone.currentIndex + 1]);
          setZoom(10);
        }, 1000);
      }
      return null;
    });

    return () => {
      intervals.forEach((interval) => {
        if (interval) clearInterval(interval);
      });
    };
  }, [drones, dispatch]);

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <GoogleMap mapContainerStyle={containerStyle} center={mapCenter} zoom={zoom}>
        {drones.map((drone,idx) => 
        {
          return (
          <React.Fragment key={drone.id}>
            {drone.path.length > 0 && <Marker label={`Drone ${idx+1}`} position={drone.path[drone.currentIndex]} 
            style={{color:"#fff"}}
            // ref={el => (markerRef.current[drone.currentIndex] = el)}
             />}
            {drone.path.length > 1 && (
              <Polyline
                path={drone.path.slice(0, drone.currentIndex + 1)}
               options={{
                  strokeColor: "#FF0000",
                  strokeOpacity: 1,
                  strokeWeight: 3
                }}

              />
            )}
          </React.Fragment>
        );}
        )}
      </GoogleMap>
    </LoadScript>
  );
};  

export default DroneGoogleMap;